import { getWarehouseByWmsName } from '@justomx/warehouse-commons'
import { UserManagment, type LoggedUser } from '@justomx/webview-commons'
import {
  getCurrentCountry,
  getCurrentWarehouse,
  getUser
} from 'client/utilities.client-helper'
import { getLoginUrl } from 'utils/environment'

export const useSessionData = () => {
  const user: LoggedUser = getUser()
  const country = getCurrentCountry()
  const warehouseCode = getCurrentWarehouse()
  const warehouse = getWarehouseByWmsName(warehouseCode)

  const logout = () => {
    UserManagment.logout()
    window.location.href = getLoginUrl()
  }

  return { user, warehouse, country, logout }
}
